module.exports = __webpack_public_path__ + "static/media/urgent_filled_small.c6810fe4.svg";